export const taskTableOption = {
  page: true,
  columnBtn: false,
  saveBtn: false,
  updateBtn: false,
  cancelBtn: false,
  viewBtn: false,
  border: true,
  addBtn: false, //新增按钮
  delBtn: false,
  editBtn: false,
  align: 'center',
  menuAlign: 'center',
  searchMenuPosition: 'right', //当前版本不支持
  expand: false, //子表格
  menuWidth: 120,
  searchMenuSpan: 4,
  column: [
    {
      label: "包编号",
      prop: 'packageNo',
      search: true,
      span: 24,
      searchSpan:5,
      width: 150
    },
    {
      label: "当前状态",
      prop: "status",
      type: "select",
      searchSpan:4,
      dicData: [{
        label: '已取消',
        value: -2
      }, {
        label: '超时放弃',
        value: -1
      }, {
        label: '待领取',
        value: 1
      }, {
        label: '待提交',
        value: 2
      }, {
        label: '已完成',
        value: 7
      }],
      span: 24,
      search: true,
      slot: true,
      width: 100
    },
    {
      label: "所属类型",
      prop: "taskType",
      slot: true,
      search: true,
      type: "select",
      searchSpan:4,
      dicData: [{
        label: '一次打标',
        value: 1
      }, {
        label: '二次打标',
        value: 2
      }],
      span: 24
    },
    {
      label: "领取译员",
      prop: "trId",
      search: true,
      searchPlaceholder: "请输入ID",
      span: 24,
      searchSpan:5,
      width: 200
    },
    {
      label: "昵称",
      prop: "nickName",
      span: 24,
      slot: true
    },
    {
      label: "手机号码",
      prop: "phone",
      span: 24,
      width: 120,
      slot: true
    },
    {
      label: "任务金额",
      prop: "amount",
      span: 24,
      width: 100,
      slot: true
    },
    {
      label: "领取时间",
      prop: "receiveTime",
      slot: true,
      span: 24,
      width: 120
    },

  ]
}


export const taskDetailOption = {
  card: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: false,
  menu: false,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  column: [
    {
      label: "原文",
      prop: "srcText",
      search: false,
    },
    {
      label: "译文",
      prop: "peText",
      slot: true,
      search: false,
    },
    {
      label: "打标结果",
      prop: "markResult",
      slot: true,
      search: false,
      width: 160
    }
  ]
}

